import NotEqualInterface from './NotEqualInterface';

export default class NotEqual implements NotEqualInterface
{
  validate(valueToCompare: unknown, secondValue: unknown): boolean {
    return valueToCompare !== secondValue
  }
}
